import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import Competition from "../Components/Pages/Competition";
import {
  DEFAULT_LOCALE,
  STORAGE_KEY,
  getLanguage,
  isSupportedLocale,
} from "../i18n";

const readPreferredLocale = () => {
  try {
    return getLanguage(localStorage.getItem(STORAGE_KEY) || DEFAULT_LOCALE)
      .locale;
  } catch {
    return DEFAULT_LOCALE;
  }
};

const RootRedirect = () => <Navigate to={`/${readPreferredLocale()}`} replace />;

const LocaleCompetition = () => {
  const { locale } = useParams();
  if (!isSupportedLocale(locale)) {
    return <Navigate to={`/${DEFAULT_LOCALE}`} replace />;
  }
  return <Competition />;
};

const Routers = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/:locale" element={<LocaleCompetition />} />
        <Route path="*" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />
      </Routes>
    </Layout>
  );
};

export default Routers;
